var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "control-block", class: { filled: _vm.email } }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim",
            value: _vm.email,
            expression: "email",
            modifiers: { trim: true }
          }
        ],
        attrs: {
          type: "email",
          id: "email",
          autocomplete: "off",
          maxlength: "255"
        },
        domProps: { value: _vm.email },
        on: {
          focusout: function($event) {
            !_vm.registrationDetails.email
              ? (_vm.errorMessages.email = true)
              : (_vm.errorMessages.email = false)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.email = $event.target.value.trim()
          },
          blur: function($event) {
            return _vm.$forceUpdate()
          }
        }
      }),
      _vm._v(" "),
      _c("label", { staticClass: "control-label" }, [
        _vm._v(_vm._s(_vm.$t("Account.Join.Email"))),
        _c("span", { staticClass: "control-label-required" }, [_vm._v(" *")])
      ])
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.errorMessages.email
        ? _c("div", {
            staticClass: "vmsg invalid",
            attrs: { id: "err_msg_email_missing" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("Account.Join.ErrorMsg.Email"))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMessages.emailValid
        ? _c("div", {
            staticClass: "vmsg invalid",
            attrs: { id: "err_msg_email_invalid" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("Account.Join.ErrorMsg.EmailInvalid"))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.errorR === "duplicateemail"
        ? _c("div", {
            staticClass: "vmsg invalid",
            attrs: { id: "err_msg_email_invalid" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("Account.Join.ErrorMsg.EmailDuplicate"))
            }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "control-block", class: { filled: _vm.userName } },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model.trim",
              value: _vm.userName,
              expression: "userName",
              modifiers: { trim: true }
            }
          ],
          attrs: {
            type: "text",
            id: "username",
            autocomplete: "off",
            maxlength: _vm.vldUsernameMaxLength
          },
          domProps: { value: _vm.userName },
          on: {
            focusout: function($event) {
              !_vm.registrationDetails.userName
                ? (_vm.errorMessages.userName = true)
                : (_vm.errorMessages.userName = false)
            },
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.userName = $event.target.value.trim()
            },
            blur: function($event) {
              return _vm.$forceUpdate()
            }
          }
        }),
        _vm._v(" "),
        _c("label", { staticClass: "control-label" }, [
          _vm._v(_vm._s(_vm.$t("Account.Join.UserName"))),
          _c("span", { staticClass: "control-label-required" }, [_vm._v(" *")])
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", [
      _vm.errorMessages.userName
        ? _c("div", {
            staticClass: "vmsg invalid",
            attrs: { id: "err_msg_username_missing" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("Account.Join.ErrorMsg.UserName"))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMessages.userNameLength
        ? _c("div", {
            staticClass: "vmsg invalid",
            attrs: { id: "err_msg_username_length" },
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("Account.Join.ErrorMsg.UserNameLength", {
                  minLength: _vm.vldUsernameMinLength
                })
              )
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMessages.userNameSymbol
        ? _c("div", {
            staticClass: "vmsg invalid",
            attrs: { id: "err_msg_username_symbol" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("Account.Join.ErrorMsg.UserNameSymbol"))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.errorR === "usernametaken"
        ? _c("div", {
            staticClass: "vmsg invalid",
            attrs: { id: "err_msg_email_invalid" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("Account.Join.ErrorMsg.UsernameTaken"))
            }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "control-block", class: { filled: _vm.pass } }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim",
            value: _vm.pass,
            expression: "pass",
            modifiers: { trim: true }
          }
        ],
        attrs: {
          type: _vm.showPassword ? "text" : "password",
          id: "password",
          autocomplete: "new-password",
          maxlength: _vm.vldPasswordMaxLength
        },
        domProps: { value: _vm.pass },
        on: {
          focusout: function($event) {
            !_vm.registrationDetails.pass
              ? (_vm.errorMessages.pass = true)
              : (_vm.errorMessages.pass = false)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.pass = $event.target.value.trim()
          },
          blur: function($event) {
            return _vm.$forceUpdate()
          }
        }
      }),
      _vm._v(" "),
      _c("label", { staticClass: "control-label" }, [
        _vm._v(_vm._s(_vm.$t("Account.Join.Pass"))),
        _c("span", { staticClass: "control-label-required" }, [_vm._v(" *")])
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "show_hide",
          class: { show_hide_hidden: _vm.showPassword },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.toggleShowPassword()
            }
          }
        },
        [
          _vm._v(
            _vm._s(
              _vm.showPassword
                ? _vm.$t("MyAccount.HidePassword")
                : _vm.$t("MyAccount.ShowPassword")
            )
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _vm.errorMessages.pass
        ? _c("div", {
            staticClass: "vmsg invalid",
            attrs: { id: "err_msg_pwd_missing" },
            domProps: {
              innerHTML: _vm._s(_vm.$t("Account.Join.ErrorMsg.Pass"))
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.errorMessages.passStrength
        ? _c("div", {
            staticClass: "vmsg invalid",
            attrs: { id: "err_msg_pwd_strength" },
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("Account.Join.ErrorMsg.PassStrength", {
                  pwdMinLength: _vm.vldPasswordMinLength
                })
              )
            }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.isRafPromo
      ? _c(
          "div",
          { staticClass: "control-block", class: { filled: _vm.promo } },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.promo,
                  expression: "promo",
                  modifiers: { trim: true }
                }
              ],
              attrs: { type: "text", id: "promo", autocomplete: "off" },
              domProps: { value: _vm.promo },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.promo = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            _c(
              "label",
              { key: "pd_promo_label", staticClass: "control-label" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("Account.Join.PromoCode")) +
                    "\n    "
                )
              ]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _vm.errorR === "PromoCodeIsInvalid"
        ? _c("div", {
            staticClass: "vmsg invalid",
            attrs: { id: "err_msg_email_invalid" },
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("Account.Join.ErrorMsg.PromoCodeIsInvalid")
              )
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.errorR === "PromoCodeIsNotValidAnymore"
        ? _c("div", {
            staticClass: "vmsg invalid",
            attrs: { id: "err_msg_email_invalid" },
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("Account.Join.ErrorMsg.PromoCodeIsNotValidAnymore")
              )
            }
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div")
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-684f6af6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-684f6af6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/Registration/RegStep1.vue
// module id = null
// module chunks = 